import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import axios from "axios";
import CheckboxTree from "react-checkbox-tree";
// import styled from "styled-components";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
// import "../treeView/siteListStyle.css";

const DownTimeSiteListTree = ({
  groupID,
  getAuth,
  refreshCheck,
  setSiteArray,
  setGroupName,
  userRefOrSiteName,
  lastChecked,
}) => {
  const navigate = useNavigate();

  const [nodes, setNodes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [checked, setChecked] = useState([]);
  const [tempChecked, setTempChecked] = useState([]);
  // const [lastKnownChecked, setLastKnownChecked] = useState([]);
  const [expanded, setExpanded] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [filteredNodes, setFilteredNodes] = useState(nodes);
  const [finalNodes, setFinalNodes] = useState([]);

  // const CustomBox = styled.div`
  //   .rct-checkbox {
  //     display: none !important;
  //   }
  // `;
  useEffect(() => {
    console.log("nodes", nodes);
    console.log("filteredNodes", filteredNodes);
    console.log("SLT userRefOrSiteName", userRefOrSiteName);
    // setLastKnownChecked(lastChecked);
  }, []);
  // useEffect(() => {
  //   console.log("lastChecked", lastChecked);
  //   setChecked(lastChecked);
  // }, [lastChecked]);
  useEffect(() => {
    getSiteList();
  }, [groupID]);
  useEffect(() => {
    console.log("siteList nodes", nodes);
    filterTree();
  }, [nodes]);
  useEffect(() => {
    filterTree();
  }, [filterText]);
  // useEffect(() => {
  //   if (checked.length === 0 && tempChecked.length > 0) {
  //     setChecked(tempChecked);
  //     setTempChecked([]);
  //   }
  // }, [checked, tempChecked]);
  // useEffect(() => {
  //   setChecked([]);
  //   if (tempChecked.length > 0) {
  //     setChecked(tempChecked);
  //     setTempChecked([]);
  //   }
  // }, [tempChecked]);
  useEffect(() => {
    if (checked.length === 0) {
      return;
    } else {
      console.log("Checked UE ", checked);
      checkSiteIds(checked);
    }
  }, [checked]);
  useEffect(() => {
    console.log("filteredNodes in ue", filteredNodes);
    if (filteredNodes.length > 0) {
      setFinalNodes(showUrOrSn(filteredNodes, userRefOrSiteName));
    }
  }, [filteredNodes]);
  useEffect(() => {
    console.log("finalNodes in ue", finalNodes);
    setIsLoading(false);
  }, [finalNodes]);

  const getSiteList = async () => {
    const authT = getAuth();
    setIsLoading(true);
    if (groupID == 0) {
      return;
    } else {
      if (authT) {
        try {
          const res = await axios.get(`https://api.pramsplus.com/group-sites`, {
            params: { group: groupID },
            headers: { Authorization: `Bearer ${authT}` },
          });
          console.log("site list api call success");
          // setIsLoading(false);
          setNodes(res.data);
          filterTree();
          return res.data;
        } catch (err) {
          console.log(err.response.status);
          if (err.response.status === 401) {
            const valid = await refreshCheck("getSiteList");
            if (valid === true) {
              console.log("Retrying getSiteList api call");
              getSiteList();
            } else if (valid === false) {
              console.log("all retries failed getSiteList");
              navigate("/login");
            }
          } else if (err.response.status === 404) {
            console.log("404 error in getSiteList");
            localStorage.removeItem("LastGroupID_DataView");
            localStorage.removeItem("LastGroupName_DataView");
            setGroupName("Select a Group");
            // localStorage.setItem("LastGroupName_DataView", "Select a Group");
            return;
          }else {
            console.log(
              "Redirecting to login something went wrong in getSiteList"
            );
            navigate("/login");
          }
          return;
        }
      }
    }
  };
  const checkSiteIds = (array) => {
    const filteredItems = array.filter((array) => !/[a-zA-Z]/.test(array));
    setSiteArray(filteredItems);
  };
  const onCheck = (newChecked) => {
    console.log("onCheck: setting temped checked to", newChecked);
    // * ISSUE#63 - To stop the need to double click the site to get data to load. Keeping commented out code for now.
    // const previousChecked = [...checked];
    // console.log("previousChecked", previousChecked);
    // setChecked([]);
    // Clear the checked state first
    // const filteredChecked = newChecked.filter(
    //   (item) => !previousChecked.includes(item)
    // );
    // console.log("filteredChecked", filteredChecked);
    // setTempChecked(newChecked); // Store the new value temporarily
    setChecked(newChecked);
  };
  const onExpand = (expanded) => {
    setExpanded(expanded);
  };
  const onFilterChange = (event) => {
    setFilterText(event.target.value);
  };
  const filterTree = () => {
    if (!filterText) {
      // console.log("no filter text");
      setFilteredNodes(nodes);
      return;
    }
    setFilteredNodes(nodes.reduce(filterNodes, []));
  };
  const filterNodes = (filtered, node) => {
    const children = (node.children || []).reduce(filterNodes, []);
    // console.log("children", children);
    if (
      // Node's label matches the search string
      node.label.toLocaleLowerCase().indexOf(filterText.toLowerCase()) > -1 ||
      // Or a children has a matching node
      children.length
    ) {
      filtered.push({ ...node, children });
    }
    return filtered;
  };
  const changeDataLabels = (data) => {
    console.log("CDL object data", data);
    const toggledData = {
      ...data,
      children: data.children.map((child) => ({
        ...child,
        label: child.title,
        title: child.label,
      })),
    };
    console.log("toggledData data:", toggledData);
    return toggledData;
  };
  const showUrOrSn = (data, userRefOrSiteName) => {
    console.log(" showUrOrSn object data", data);
    console.log("showUrOrSn userRefOrSiteName", userRefOrSiteName);
    if (userRefOrSiteName === "SN" && data) {
      const modifiedData = data.map((item) => changeDataLabels(item));
      console.log("showUrOrSn SN ", modifiedData);
      return modifiedData;
    } else {
      console.log("showUrOrSn UR ", userRefOrSiteName);
      return data;
    }
  };
  if (isLoading) {
    return <>Loading...</>;
  }
  return (
    <Row style={{ width: "100%", paddingBottom: "5px" }}>
      <Col style={{ padding: 0 }}>
        <input
          className="filter-text"
          placeholder="Search..."
          type="text"
          value={filterText}
          onChange={onFilterChange}
          style={{ borderRadius: "5px", padding: "7px", width: "285px" }}
        />
        <Row
          id="RowTreeHolder"
          style={{
            overflowY: "scroll",
            maxHeight: "670px",
          }}
        >
          {/* <CustomBox> */}
            <CheckboxTree
              checked={checked}
              expanded={expanded}
              nodes={finalNodes}
              showExpandAll
              expandOnClick
              onCheck={onCheck}
              onExpand={onExpand}
              showNodeIcon={true}
              optimisticToggle={false}
            />
          {/* </CustomBox> */}
        </Row>
      </Col>
    </Row>
  );
};

export default DownTimeSiteListTree;
